import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Notification from '~/components/Notification';
import {Button, Link, Stack} from '@customink/pigment-react';
import {useSelector} from 'react-redux';
import {isDragNDropAnywhereEnabled as isDragNDropAnywhereEnabledSelector} from '~/selectors/ConfigSelectors';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
export default function UploadFileUnsupportedError(props) {
  const {dismiss} = props;
  const isDragNDropAnywhereEnabled = useSelector(
    isDragNDropAnywhereEnabledSelector
  );
  useEffect(() => {
    window.setChatElements?.(); // LP init
  }, []);
  return (
    <Notification
      {...props}
      title={
        <span>
          <span>{isDragNDropAnywhereEnabled ? '' : <>Oops!&nbsp;</>}</span>
          <span>Your file is an unsupported file type.</span>
        </span>
      }>
      <p>
        Accepted file types (max size 5 MB):{' '}
        {isDragNDropAnywhereEnabled
          ? 'AI, BMP, EPS, GIF, JPEG, JPG, PDF, PNG, PSD, TIF, TIFF, WEBP'
          : ' .JPG .JPEG .PNG .GIF .BMP .PDF .AI .PSD .EPS .WEBP .TIF .TIFF'}
      </p>
      <p>
        Have a different type of file?{' '}
        {isDragNDropAnywhereEnabled ? (
          <>
            <Link id="LP_upload-file-type">Chat now</Link> or email{' '}
            <Link href="mailto:service@customink.com">
              service@customink.com
            </Link>{' '}
            and we’ll have it ready for you to use within a few hours!
          </>
        ) : (
          <>
            <span>
              <Link href="#/help" onClick={dismiss}>
                Email it to us
              </Link>
            </span>{' '}
            and weʼll have it ready for you to use within a few hours!
          </>
        )}
      </p>
      <Stack className="notification-stack">
        <Button
          size="large"
          variant="secondary"
          className="notification-cta"
          onClick={dismiss}>
          Close
        </Button>
      </Stack>
    </Notification>
  );
}

const propTypes = {
  dismiss: PropTypes.func
};

UploadFileUnsupportedError.propTypes = propTypes;

UploadFileUnsupportedError.displayName = 'UploadFileUnsupportedError';
